import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - functions
import { pathHomePage, WEB_SERVICE_MIMS, applications } from "../../config/constants";
import { renderAvatar } from "../../config/functions";
// Components
import {
  PatientMainDiv,
  PatientDiv,
  UserDiv,
  AvatarLink,
  AvatarImg,
  UserInfoDiv,
  UserText,
  ShowAppsButton,
  ShowAppsImg,
  ProfileDiv,
  ProfileLink,
  ProfileImg,
  ProfileText,
  ApplicationDiv,
  ApplicationProfileLink,
  ApplicationProfileImg,
  ApplicationLink,
  ApplicationImg,
  ApplicationText,
  ApplicationProfileText,
} from "./styles";
import Axios from "../../config/axios";
import Loader from "../loader";
// Assets
import IcoProfile from "../../assets/ico_patient_profile.svg";
import IcoProfileGray from "../../assets/ico_patient_profile_gray.svg";
import IcoArrowUp from "../../assets/ico_arrow_up.svg";
import IcoArrowDown from "../../assets/ico_arrow_down.svg";
import RGSClinicActive from "../../assets/ico_clinic.svg";
import RGSHomeActive from "../../assets/ico_home.svg";
import RGSClinicDisabled from "../../assets/ico_clinic_disabled.svg";
import RGSHomeDisabled from "../../assets/ico_home_disabled.svg";
import RGSClinicGray from "../../assets/ico_clinic_gray.svg";
import RGSHomeGray from "../../assets/ico_home_gray.svg";

const PatientNavigation = ({ patientId, section, rechargeComponent }) => {
  const [isLoadingPatientData, setIsLoadingPatientData] = useState(true);
  const [showApps, setShowApps] = useState(false);
  const [user, setUser] = useState("");
  const [appsArray, setAppsArray] = useState([]);
  const [isThereSomePrescription, setIsThereSomePrescription] = useState(false);
  const [isTherePrescriptionsAfter7Days, setIsTherePrescriptionsAfter7Days] = useState(false);
  const [adherence, setAdherence] = useState(0);
  const [hospitalSoftwares, setHospitalSoftwares] = useState([]);
  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const hospitalId = useSelector(({ clinician }) => clinician.data.HOSPITAL_ID);
  const [t] = useTranslation("global");

  useEffect(() => {
    if (hospitalId !== undefined) {
      Axios("get", `${WEB_SERVICE_MIMS}/hospitals/softwares/${hospitalId}`)
        .then(({ data }) => {
          setHospitalSoftwares(data);
        })
        .catch((error) => {
          console.log("endpoint to get hospital softwares: ", error);
        });
    }
  }, [hospitalId]);

  useEffect(() => {
    const URL = `${WEB_SERVICE_MIMS}/patients/fetch/${patientId}`;
    Axios("get", URL)
      .then(({ data }) => {
        setUser(data.PATIENT_USER);
        setAppsArray(data.SOFTWARE_ID);
        setIsThereSomePrescription(data.isThereSomePrescription);
        setIsTherePrescriptionsAfter7Days(data.isTherePrescriptionsAfter7Days);
        setAdherence(data.ADHERENCE);
        setIsLoadingPatientData(false);
      })
      .catch((error) => {
        console.log("url error: ", error);
      });
  }, [patientId, rechargeComponent]);

  const handleShowApps = (e) => {
    e.preventDefault();
    setShowApps(!showApps);
  };

  const renderActiveSoftware = () => {
    let softwareImg;
    let softwareTitle;
    switch (section) {
      case "clinic":
        softwareImg = RGSClinicGray;
        softwareTitle = "iLimbApp";
        break;
      case "home":
        softwareImg = RGSHomeGray;
        softwareTitle = "iLimbApp";
        break;
      default:
        break;
    }
    return (
      <>
        <ApplicationImg src={softwareImg} alt={softwareTitle} />
        <ApplicationText>{softwareTitle}</ApplicationText>
      </>
    );
  };

  const renderSoftwares = () => {
    const getCurrentSoftwareId = () => {
      switch (section) {
        case "clinic":
          return applications.clinicId;
        case "home":
          return applications.homeId;
        default:
          break;
      }
    };
    return hospitalSoftwares.map((software) => {
      let softwareImg;
      let disabledLink = true;
      let path = "";
      const handleSetLink = (softwareId, activeImg, disabledImg, prescriptionsPath) => {
        if (appsArray.includes(softwareId)) {
          softwareImg = activeImg;
          disabledLink = false;
          path = prescriptionsPath;
        } else {
          softwareImg = disabledImg;
        }
      };
      switch (software.SOFTWARE_ID) {
        case applications.clinicId:
          handleSetLink(
            applications.clinicId,
            RGSClinicActive,
            RGSClinicDisabled,
            `${pathHomePage}/prescriptions/clinic/${clinicianToken}/${patientId}`
          );
          break;
        case applications.homeId:
          handleSetLink(
            applications.homeId,
            RGSHomeActive,
            RGSHomeDisabled,
            `${pathHomePage}/prescriptions/home/${clinicianToken}/${patientId}`
          );
          break;
        default:
          break;
      }
      return (
        <ApplicationLink key={software.SOFTWARE_ID} to={path} disabled={disabledLink}>
          {getCurrentSoftwareId() === software.SOFTWARE_ID ? (
            renderActiveSoftware()
          ) : (
            <ApplicationImg src={softwareImg} alt={software.name} />
          )}
        </ApplicationLink>
      );
    });
  };

  return (
    <>
      {isLoadingPatientData ? (
        <Loader />
      ) : (
        <PatientMainDiv>
          <PatientDiv>
            <UserDiv>
              <AvatarLink to={`${pathHomePage}/global-Patient-Adherence/${clinicianToken}/${patientId}`}>
                <AvatarImg src={renderAvatar(isThereSomePrescription, isTherePrescriptionsAfter7Days, adherence)} alt="avatar" />
              </AvatarLink>
              <UserInfoDiv>
                <UserText>{user}</UserText>
              </UserInfoDiv>
              <ShowAppsButton onClick={handleShowApps}>
                <ShowAppsImg src={showApps ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
              </ShowAppsButton>
            </UserDiv>
            <ProfileDiv>
              <ProfileLink to={`${pathHomePage}/edit-patient/${clinicianToken}/${patientId}`}>
                <ProfileImg src={section === "profile" ? IcoProfileGray : IcoProfile} alt="profile" />
                {section === "profile" && <ProfileText>{t("patientAppCard.profileButton")}</ProfileText>}
              </ProfileLink>
            </ProfileDiv>
            <ApplicationDiv show={showApps}>
              <ApplicationProfileLink to={`${pathHomePage}/edit-patient/${clinicianToken}/${patientId}`}>
                <ApplicationProfileImg src={section === "profile" ? IcoProfileGray : IcoProfile} alt="profile" />
                {section === "profile" && <ApplicationProfileText>{t("patientAppCard.profileButton")}</ApplicationProfileText>}
              </ApplicationProfileLink>
              {renderSoftwares()}
            </ApplicationDiv>
          </PatientDiv>
        </PatientMainDiv>
      )}
    </>
  );
};

export default PatientNavigation;
